<div class="add-quote-note-modal flex flex__align-items--center flex--column">
  <h1 class="text__color--black-two font__size--14 font__weight--bold">Add notes</h1>

  <div class="content w-100">
    <div class="quote-notes mt-2">
      <app-spinner
        [diameter]="50"
        [loading]="(loading$ | async)"
        [withSpinner]="true"
        [withBaseClass]="true"
        [withMinHeight]="true"
        [withoutMinHeightOnLoaded]="true">
          <app-quote-notes-view
            [items]="items">
          </app-quote-notes-view>
      </app-spinner>
    </div>

    <div class="adding-note">
      <app-quote-note-control></app-quote-note-control>
    </div>
  </div>

  <div
    md-dialog-actions class="actions flex">
    <button 
      class="actions--button flex--box"
      mat-raised-button color="warn"
      (click)="close()">
      Close
    </button>
    <button
      class="actions--button flex--box"
      mat-raised-button color="primary"
      (click)="submit()">
      Add
    </button>
  </div>
</div>
